import { Box } from '@mui/material';
import { HAIRLINE, READOUT_FONT, WARNING } from '../chrome';

/**
 * Where the notice sits: a strip over the row's panes, or a line inside
 * another surface, such as a picker.
 */
type NoticePlacement = 'strip' | 'inline';

const PLACEMENT_SX = {
    strip: { borderBottom: '1px solid', borderColor: HAIRLINE },
    inline: {},
} as const;

interface PrimaryRowNoticeProps {
    text: string;
    /** Where the notice sits; a strip over the row's panes when left out. */
    placement?: NoticePlacement;
}

/**
 * Tells the user that the primary row does not show the primary image.
 * Announced as a status, so a screen reader reads it when it appears.
 */
export default function PrimaryRowNotice({
    text,
    placement = 'strip',
}: PrimaryRowNoticeProps) {
    return (
        <Box
            role="status"
            data-testid="primary-row-notice"
            sx={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                px: 1,
                py: 0.5,
                color: WARNING,
                fontFamily: READOUT_FONT,
                fontSize: 12,
                textAlign: 'center',
                ...PLACEMENT_SX[placement],
            }}
        >
            {text}
        </Box>
    );
}
